import { FC, PropsWithChildren, useEffect, useMemo, useState } from 'react';

import { Users } from '../../../modules/interfaces';

import { useAuth, useRequest } from '../../../modules/hooks';
import { endpoints } from '../../../modules/mappers/urls';
import { UserPropertiesContext } from '../../../modules/context/userPropertiesContext';

export const UserProvider: FC<PropsWithChildren> = ({ children }) => {
  const [userPropertiesData, setUserPropertiesData] = useState<Users>();
  const { credentialsInfo } = useAuth()!;

  const userPropertiesUrl = `${endpoints.USERS}/info`;
  const [{ data, loading: userPropertiesLoading }, getInfo] = useRequest<Users>(
    userPropertiesUrl,
    'get',
    {
      authToken: credentialsInfo?.token,
    },
    { manual: true },
  );

  useEffect(() => {
    if (!credentialsInfo?.token) return;

    getInfo();
  }, [credentialsInfo?.token]);

  useEffect(() => {
    if (!data) return;

    setUserPropertiesData(data.result);
  }, [data]);

  const propertiesContext = useMemo(() => {
    return { userPropertiesData, userPropertiesLoading, getInfo };
  }, [userPropertiesData, userPropertiesLoading, getInfo]);

  return (
    <UserPropertiesContext.Provider value={propertiesContext}>
      {children}
    </UserPropertiesContext.Provider>
  );
};
